import $http from "@/plugins/axios";
import AppService from "@/services/app.service";

export const BaseService = name => {
    let base = {
        name: name,
        search (filter) {
            return $http.get(`${base.name}/`, { params: AppService.mapFilterPagination(filter) })
        },
        create (model) {
            return $http.post(`${base.name}/`, model)
        },
        read (id) {
            return $http.get(`${base.name}/${id}/`)
        },
        update (id, model) {
            return $http.patch(`${base.name}/${id}/`, model)
        },
        replace (id, model) {
            return $http.put(`${base.name}/${id}/`, model)
        },
        delete (id) {
            return $http.delete(`${base.name}/${id}/`)
        }
    }
    return base
}

export const BaseServiceLevel2 = (name1, name2) => {
    let base = {
        name: [name1, name2],
        name1: name1,
        name2: name2,
        search (id_1, filter) {
            return $http.get(`${base.name1}/${id_1}/${base.name2}/`, { params: AppService.mapFilterPagination(filter) })
        },
        create (id_1, model) {
            return $http.post(`${base.name1}/${id_1}/${base.name2}/`, model)
        },
        read (id_1, id_2) {
            return $http.get(`${base.name1}/${id_1}/${base.name2}/${id_2}/`)
        },
        update (id_1, id_2, model) {
            return $http.patch(`${base.name1}/${id_1}/${base.name2}/${id_2}/`, model)
        },
        replace (id_1, id_2, model) {
            return $http.put(`${base.name1}/${id_1}/${base.name2}/${id_2}/`, model)
        },
        delete (id_1, id_2) {
            return $http.delete(`${base.name1}/${id_1}/${base.name2}/${id_2}/`)
        }
    }
    return base
}

export default BaseService
